import React from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';

function DragCircles({
  height,
  width
}) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 11 22",
    width: width,
    height: height,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "2",
    r: "2",
    fill: "#DDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "11",
    r: "2",
    fill: "#DDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "2",
    cy: "20",
    r: "2",
    fill: "#DDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "2",
    r: "2",
    fill: "#DDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "11",
    r: "2",
    fill: "#DDD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "20",
    r: "2",
    fill: "#DDD"
  }));
}

DragCircles.defaultProps = {
  width: 11,
  height: 22
};
DragCircles.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default DragCircles;